






























import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IAccount } from "@/models/accounts";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "vault-provider": () =>
      import("@/components/app/global/vault/vaultProvider.vue"),
    "vault-note-form": () =>
      import("@/components/app/global/vault/vaultNoteForm.vue"),
    "vault-notes-listing": () =>
      import("@/components/app/global/vault/vaultNotesListing.vue")
  }
})
export default class ClientNotesComponent extends Vue {
  // Props

  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise"].includes(tag)
  })
  public readonly tag!: string;

  @Prop({ required: true })
  public accountId!: IAccount["id"];

  @Prop({ required: false })
  public client!: IClient;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Computed

  public get brandName() {
    return this.$store.state.brand?.name;
  }

  public get vaultProviderProps() {
    return {
      accountId: this.accountId,
      clientId: this.client?.id,
      dataScope: `$client_${this.client?.id}_notes`,
      id: "CNVP", // [C]lient [N]otes [V]ault [P]rovider
      limit: 3,
      manualFilters: {
        "filter[encrypted]": false
      }
    };
  }
}
